import { useCallback, useEffect, useState } from 'react';

import { useStorageToken } from '~lib/auth/use-storage-token';
import { loadDatasets, type Dataset } from '~lib/storage/datasets';

type Status = 'idle' | 'loading' | 'success' | 'error';

interface UseDatasetsResult {
  status: Status;
  datasets: Dataset[];
  error: Error | null;
  refresh: () => void;
}

export function useDatasets(): UseDatasetsResult {
  const getToken = useStorageToken();
  const [status, setStatus] = useState<Status>('idle');
  const [datasets, setDatasets] = useState<Dataset[]>([]);
  const [error, setError] = useState<Error | null>(null);

  const run = useCallback(async () => {
    setStatus('loading');
    setError(null);
    try {
      const token = await getToken();
      const result = await loadDatasets(token);
      setDatasets(result);
      setStatus('success');
    } catch (e) {
      setError(e instanceof Error ? e : new Error(String(e)));
      setStatus('error');
    }
  }, [getToken]);

  useEffect(() => {
    void run();
  }, [run]);

  return { status, datasets, error, refresh: run };
}
